import { createRoot } from "react-dom/client";
import TripApplicationModalWrapper from "../components/TripApplicationModalWrapper";

class TripModalElement extends HTMLElement {
  connectedCallback() {
    const root = createRoot(this.attachShadow({ mode: 'open' }));    
    root.render(<TripApplicationModalWrapper />);
  }
}

customElements.define('trip-modal', TripModalElement);